export default {
  title: 'نصب و راه‌اندازی',
  form: {
    subtitle: 'گزارش فنی میدانی — جزئیات بازدید و تجهیزات.',
    devices: 'تجهیزات',
    installedEquipment: 'تجهیزات',
    deviceUsed: 'استفاده شده',
    deviceUsedHint: 'در صورت استفاده از این دستگاه در این نصب، روشن کنید.',
    salesDevice: 'فروش',
  },
  assign: {
    title: 'تخصیص نصب',
    description: 'این صفحه شامل فرم تخصیص نصب‌های جدید یا تخصیص مجدد نصب‌های موجود خواهد بود.'
  },
  actions: {
    assign: 'تخصیص نصب',
    update: 'بروزرسانی/تایید',
    copyId: 'کپی شناسه نصب',
    remove: 'حذف نصب',
    createppoe: 'ایجاد PPOE'
  },
  status: {
    awaiting: 'در انتظار',
    pending: 'در انتظار',
    inProgress: 'در حال انجام',
    done: 'انجام شده',
    failed: 'ناموفق'
  },
  types: {
    all: 'همه',
    installation: 'نصب',
    troubleshooting: 'عیب‌یابی',
    installers: 'نصاب‌ها',
    feedback: 'بازخورد مشتریان'
  },
  notAvailable: '—',
  yes: 'بله',
  no: 'خیر',
  columns: {
    customer: 'مشتری',
    createdBy: 'ایجادکننده',
    installer: 'نصاب',
    status: 'وضعیت',
    nocApproved: 'تأیید ناک',
    devices: 'تجهیزات',
    type: 'نوع',
    result: 'نتایج',
    photos: 'تصاویر'
  },
  installerDetails: {
    title: 'نصاب',
    name: 'نام',
    email: 'ایمیل',
    branch: 'شعبه',
    role: 'نقش',
    notAssigned: 'تخصیص داده نشده',
    assignedAt: 'تاریخ و زمان تخصیص',
  },
  nocApproved: {
    yes: 'بله',
    no: 'خیر',
  },
  customerDetails: {
    title: 'جزئیات مشتری',
    id: 'شناسه قرارداد',
    nameEn: 'نام (انگلیسی)',
    nameFa: 'نام (فارسی)',
    company: 'شرکت',
    type: 'نوع مشتری',
    email: 'ایمیل',
    address: 'آدرس',
    phone: 'تلفن',
    mobile: 'موبایل',
    contractNote: 'یادداشت قرارداد'
  },
  resultDetails: {
    title: 'نتایج نصب'
  },
  approve: {
    statusRequiredTitle: 'هنوز قابل تأیید نیست',
    statusRequiredBody: 'قبل از تأیید، وضعیت نصب را روی «انجام شده» یا «ناموفق» بگذارید.',
    confirmTitle: 'تأیید نصب؟',
    confirmBody: 'این نصب تأیید شود؟',
    confirmDevicesSyncIntro: 'تجهیزات این نصب با پرونده مشتری یکسان نیست.',
    confirmDevicesSyncFooter: 'آیا این نصب را تأیید می‌کنید؟',
    diffAdded: '+ {name} × {qty}',
    diffRemoved: '− {name} × {qty}',
    diffQtyChanged: '{name}: {fromQty} → {toQty}',
    cancel: 'لغو',
    successTitle: 'تأیید شد',
    successBody: 'نصب با موفقیت تأیید شد.',
    errorTitle: 'خطا در تأیید',
    errorBody: 'تأیید این نصب انجام نشد.',
  },
  deviceDetails: {
    title: 'تجهیزات',
    name: 'نام',
    quantity: 'تعداد',
    noDevices: 'بدون تجهیزات',
    count: '{n} دستگاه'
  },
  notifications: {
    idCopied: {
      title: 'شناسه نصب کپی شد',
      description: 'شناسه نصب در کلیپ‌بورد کپی شد.'
    },
    deleted: {
      title: 'نصب حذف شد',
      description: 'نصب با موفقیت حذف شد.'
    },
    ppoeCreated: {
      title: 'ppoe ایجاد شد',
      description: 'حساب PPOE با موفقیت ایجاد شد.'
    },
    error: {
      title: 'خطا',
      description: 'حذف نصب با خطا مواجه شد. لطفا مجددا تلاش کنید.'
    }
  }
} 